import { useSelector } from "react-redux";

import { SubscriptionStatus } from "../const/subscription";
import { getDetails, getIsFetchingDetails } from "../model/selectors/subscriptionSelectors";

export const useSubscription = () => {
  const isFetchingDetails = useSelector(getIsFetchingDetails);
  const details = useSelector(getDetails);

  return {
    isFetching: isFetchingDetails || false,
    isActive:
      details?.currentSubscriptionStatus === SubscriptionStatus.MonthlyActive ||
      details?.currentSubscriptionStatus === SubscriptionStatus.YearlyActive,
    status: details?.currentSubscriptionStatus,
  };
};
